import { ZodNullable, ZodString, core, z } from "zod";

import type { Writable } from "./shared.ts";

function isBlank(value: unknown): boolean {
  return typeof value === "string" && value.trim() === "";
}

const NullableStrictString: core.$constructor<ZodNullable<ZodString>> =
  core.$constructor("NullableStrictString", (inst, def) => {
    ZodNullable.init(inst, def);

    const parse = inst._zod.parse.bind(inst._zod);

    inst._zod.parse = (
      payload,
      ctx,
    ): core.util.MaybeAsync<core.ParsePayload> => {
      if (isBlank(payload.value)) {
        payload.value = null;
      }

      return parse(payload, ctx);
    };
  });

const StrictString: core.$constructor<ZodString> = core.$constructor(
  "StrictString",
  (inst, def) => {
    ZodString.init(inst, def);

    inst.nullable = () =>
      new NullableStrictString({ innerType: inst, type: "nullable" });

    inst.nullish = () => inst.nullable().optional();
  },
);

const ZodStringProto: Writable<ZodString> = Object.getPrototypeOf(z.string());

ZodStringProto.verbatim = function verbatim(this: ZodString): ZodString {
  return z.string();
};

export function string(): ZodString {
  return new StrictString({ checks: [], type: "string" }).trim().nonempty();
}
